module.exports = __webpack_public_path__ + "static/img/3.37d2d03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/3.jpg
// module id = B89t
// module chunks = 4